<template>
  <div id="messages-filter">
    <f7-block class='filterChipBlock' style="margin-top:0px;">
      <div class="chip statusChip">
        <div class="chip-label">Status</div>
        <a href="#" class="chip-delete" @click="onFilterChipDelete('statusChip')"></a>
      </div>
      <f7-chip class="dateBeginChip" text="Starting Date" deleteable @delete="onFilterChipDelete('dateBeginChip')"></f7-chip>
      <f7-chip class="dateEndChip" text="End Date" deleteable @delete="onFilterChipDelete('dateEndChip')"></f7-chip>
      <f7-chip class="reasonChip" text="Reason" deleteable @delete="onFilterChipDelete('reasonChip')"></f7-chip>
      <div class="chip creditorNameChip">
        <div class="chip-label" v-if="received && isPayments">Sender Name</div>
        <div class="chip-label" v-if="!received && isPayments">Recipient Name</div>
        <a href="#" class="chip-delete" @click="onFilterChipDelete('creditorNameChip')"></a>
      </div>
    </f7-block>
    <f7-list accordion id="directPayments-filter">
      <f7-list-item class="listBackground filterFontSize" accordion-item title="Filter by" id="filter-item">
        <f7-accordion-content>
          <f7-list>
            <div class="showSmallScreenOnly">
              <!-- <div class="panel21 panel-default"> -->
              <div class="row">
                <div class="col-md-4 offset-md-1">
                  <f7-list-item class="filterTypes" v-if="isPayments">
                    <f7-label class="filterFontSize filterLabelWidth">Status</f7-label>
                    <p class="statusPickerLink">
                      <a href="#" data-picker=".statusPicker" class="open-picker" style="font-size:14px;margin-left: 10px;">
                        <i class="icon icon-status-label" v-if="getIcon(filterStatusWaiting, filterStatusNegotiationRequest,
                        filterStatusNegotiationResponse, filterStatusRequestAccepted,
                        filterStatusRequestAborted, filterStatusCreditTransferGenerated,
                        filterStatusBankStatementReceived, filterStatusDirectPayments) !== ''" v-bind:class="getIcon(filterStatusWaiting, filterStatusNegotiationRequest,
                        filterStatusNegotiationResponse, filterStatusRequestAccepted,
                        filterStatusRequestAborted, filterStatusCreditTransferGenerated,
                        filterStatusBankStatementReceived, filterStatusDirectPayments)"></i> {{ statusPickerLabel }}
                      </a>
                    </p>
                  </f7-list-item>
                </div>
                <div class="col-md-4">
                  <f7-list-item class="filterTypes filterFontSize">
                    <f7-label class="filterLabelWidth">Starting Date</f7-label>
                    <div class="filterFontSize"
                    v-if="hasDatePicker === true"
                    style="width: 100%;margin-left: 10px;"
                    @click="calendarDateBegin($event)"
                    >{{paymentsDateBegin()}}</div>
                    <input class="filterFontSize"
                    v-else
                    style="height:auto;line-height:normal;margin-left: 10px;color: #A7A7A7;"
                    type="date"
                    placeholder="Select a date"
                    v-model="filterDateBegin">
                    <!-- <input class="filterFontSize"
                    style="height:auto;"
                    type="text"
                    @click="calendarDateBegin($event)"
                    placeholder="Select a date"
                    v-model="filterDateBegin"> -->
                  </f7-list-item>
                </div>
                <div class="col-md-2"/>
              </div>
              <div class="row">
                <div class="col-md-4 offset-md-1">
              <f7-list-item class="filterTypes filterFontSize">
                <f7-label class="filterLabelWidth">End Date</f7-label>
                <div class="filterFontSize"
                v-if="hasDatePicker === true"
                style="width: 100%;margin-left: 10px"
                @click="calendarDateEnd($event)"
                >{{paymentsDateEnd()}}</div>
                <input class="filterFontSize"
                v-else
                style="height:auto;line-height:normal;margin-left: 10px;color: #A7A7A7;"
                type="date"
                placeholder="Select a date"
                v-model="filterDateEnd">
                <!-- <input class="filterFontSize"
                style="height:auto;"
                type="text"
                @click="calendarDateEnd($event)"
                placeholder="Select a date"
                v-model="filterDateEnd"> -->
              </f7-list-item>
            </div>
            <div class="col-md-4">
              <f7-list-item v-if="isPayments" class="filterTypes filterFontSize">
                <f7-label class="filterLabelWidth">Reason</f7-label>
                <input class="filterFontSize" placeholder="Reason" style="height:auto;margin-left: 10px;" type="text" v-model="filterReason"></input>
              </f7-list-item>
            </div>
            <div class="col-md-2"/>
          </div>
          <div class="row">
            <div class="col-md-4 offset-md-1">
              <f7-list-item class="filterTypes filterFontSize" v-if="received && isPayments">
                <f7-label class="filterLabelWidth">Sender Name</f7-label>
                <input class="filterFontSize" placeholder="Sender Name" style="height:auto;margin-left: 10px" type="text" v-model="filterName"></input>
              </f7-list-item>
              <f7-list-item class="filterTypes filterFontSize" v-if="!received && isPayments">
                <f7-label class="filterLabelWidth">Recipient Name</f7-label>
                <input class="filterFontSize" placeholder="Recipient Name" style="height:auto;margin-left: 10px;" type="text" v-model="filterName"></input>
              </f7-list-item>
            </div>
            </div>
          <!--  </div> -->
          </div>
          <div class="showLargeScreenOnly">
            <div class="form-control row">
              <div class="input-wrap">
                <div class="input-field">
                  <label>Status</label>
                  <p class="statusPickerLink" >
                    <a href="#" data-picker=".statusPicker" class="open-picker" style="font-size:14px;">
                      <i class="icon icon-status-label" v-if="getIcon(filterStatusWaiting, filterStatusNegotiationRequest,
                      filterStatusNegotiationResponse, filterStatusRequestAccepted,
                      filterStatusRequestAborted, filterStatusCreditTransferGenerated,
                      filterStatusBankStatementReceived, filterStatusDirectPayments) !== ''" v-bind:class="getIcon(filterStatusWaiting, filterStatusNegotiationRequest,
                      filterStatusNegotiationResponse, filterStatusRequestAccepted,
                      filterStatusRequestAborted, filterStatusCreditTransferGenerated,
                      filterStatusBankStatementReceived, filterStatusDirectPayments)"></i> {{ statusPickerLabel }}
                    </a>
                  </p>
                </div>
              </div>
              <div class="input-wrap">
                <div class="input-field">
                  <label>Starting Date</label>
                  <div class=""
                  v-if="hasDatePicker === true"
                  style="width: 100%; "
                  @click="calendarDateBegin($event)"
                  >{{paymentsDateBegin()}}</div>
                  <input class="filterFontSize"
                  v-else
                  style="height:auto;line-height:normal;color: #A7A7A7;"
                  type="date"
                  placeholder="Select a date"
                  v-model="filterDateBegin">
                </div>
              </div>
              <div class="input-wrap">
                <div class="input-field">
                  <label>End Date</label>
                  <div class=""
                  v-if="hasDatePicker === true"
                  style="width: 100%; color:;"
                  @click="calendarDateEnd($event)"
                  >{{paymentsDateEnd()}}</div>
                  <input class="filterFontSize"
                  v-else
                  style="height:auto;line-height:normal;color: #A7A7A7"
                  type="date"
                  placeholder="Select a date"
                  v-model="filterDateEnd">
                </div>
              </div>
              <div class="input-wrap">
                <div class="input-field">
                  <f7-label class="">Reason</f7-label>
                  <input class="filterFontSize" placeholder="Reason" style="height:auto;" type="text" v-model="filterReason"></input>
                </div>
              </div>
              <div class="input-wrap" v-if="received && isPayments">
                <div class="input-field">
                  <f7-label class="filterLabelWidth">Sender Name</f7-label>
                  <input class="filterFontSize" placeholder="Sender Name" style="height:auto;" type="text" v-model="filterName"></input>
                </div>
              </div>
              <div class="input-wrap" v-if="!received && isPayments">
                <div class="input-field">
                  <f7-label class="">Recipient Name</f7-label>
                  <input class="filterFontSize" placeholder="Recipient Name" style="height:auto;" type="text" v-model="filterName"></input>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <li class="item-content filterTypes filterFontSize" style="padding-left: 0px;">
              <div class="item-inner">
                <div class="item-after">
                  <f7-button class="button-round statusButton " fill @click="saveDefaultFilter">Save filter</f7-button>
                  <f7-button class="button-round statusButton " fill @click="cleanFilter">Clean filter</f7-button>
                  <f7-button class="button-round statusButton" fill @click="updatePaymentsList">Apply filter</f7-button>
                </div>
              </div>
            </li>
          </div>
          </f7-list>
        </f7-accordion-content>
      </f7-list-item>
    </f7-list>
    <div class="picker-modal statusPicker">
      <div class="toolbar">
        <div class="toolbar-inner">
          <div class="left"></div>
          <div class="right"><a href="#" class="close-picker" @click="">OK</a></div>
        </div>
      </div>
      <!-- TODO -->
      <div class="picker-modal-inner scrollablePicker">
        <!-- TODO -->
        <div class="list-block">
          <ul>
            <li>
              <label class="label-checkbox item-content">
                <input type="checkbox" class="checkboxFilterStatusWaiting" @change="changeFilterStatusWaiting" v-bind:value="filterStatusWaiting">
                <div class="item-media">
                  <i class="icon icon-form-checkbox"></i>
                </div>
                <div class="item-inner">
                  <div class="item-title">
                    Request Waiting <i class="icon-clock_forward icon icon-status-label"></i>
                  </div>
                </div>
              </label>
            </li>
            <!--<li>
              <label class="label-checkbox item-content">
                <input type="checkbox" class="checkboxFilterStatusNegotiationRequest" @change="changeFilterStatusNegotiationRequest" v-bind:value="filterStatusNegotiationRequest">
                <div class="item-media">
                  <i class="icon icon-form-checkbox"></i>
                </div>
                <div class="item-inner">
                  <div class="item-title">
                    Negotiation Request <i class="icon-message icon icon-status-label"></i>
                  </div>
                </div>
              </label>
            </li>

            <li>
              <label class="label-checkbox item-content">
                <input type="checkbox" class="checkboxFilterStatusNegotiationResponse" @change="changeFilterStatusNegotiationResponse" v-bind:value="filterStatusNegotiationResponse">
                <div class="item-media">
                  <i class="icon icon-form-checkbox"></i>
                </div>
                <div class="item-inner">
                  <div class="item-title">
                    Negotiation Response <i class="icon-messages icon icon-status-label"></i>
                  </div>
                </div>
              </label>
            </li>-->
            <li>
              <label class="label-checkbox item-content">
                <input type="checkbox" class="checkboxFilterStatusRequestAccepted" @change="changeFilterStatusRequestAccepted" v-bind:value="filterStatusRequestAccepted">
                <div class="item-media">
                  <i class="icon icon-form-checkbox"></i>
                </div>
                <div class="item-inner">
                  <div class="item-title">
                    Request Accepted <i class="icon-ok icon icon-status-label"></i>
                  </div>
                </div>
              </label>
            </li>
            <li>
              <label class="label-checkbox item-content">
                <input type="checkbox" class="checkboxFilterStatusRequestAborted" @change="changeFilterStatusRequestAborted" v-bind:value="filterStatusRequestAborted">
                <div class="item-media">
                  <i class="icon icon-form-checkbox"></i>
                </div>
                <div class="item-inner">
                  <div class="item-title">
                    Request Aborted <i class="icon-error icon icon-status-label"></i>
                  </div>
                </div>
              </label>
            </li>
            <li>
              <label class="label-checkbox item-content">
                <input type="checkbox" class="checkboxFilterStatusCreditTransferGenerated" @change="changeFilterStatusCreditTransferGenerated" v-bind:value="filterStatusCreditTransferGenerated">
                <div class="item-media">
                  <i class="icon icon-form-checkbox"></i>
                </div>
                <div class="item-inner">
                  <div class="item-title">
                    Credit Transfer Generated <i class="icon-hand_money icon icon-status-label"></i>
                  </div>
                </div>
              </label>
            </li>
            <li>
              <label class="label-checkbox item-content">
                <input type="checkbox" class="checkboxFilterStatusBankStatementReceived" @change="changeFilterStatusBankStatementReceived" v-bind:value="filterStatusBankStatementReceived">
                <div class="item-media">
                  <i class="icon icon-form-checkbox"></i>
                </div>
                <div class="item-inner">
                  <div class="item-title">
                    Bank Statement Received <i class="icon-receipt icon icon-status-label"></i>
                  </div>
                </div>
              </label>
            </li>
            <li>
              <label class="label-checkbox item-content">
                <!-- <input type="checkbox" name="paymentsStatusCheckbox" value="Direct Payments"> -->
                <input type="checkbox" class="checkboxFilterStatusDirectPayments" @change="changeFilterStatusDirectPayments" v-bind:value="filterStatusDirectPayments">
                <div class="item-media">
                  <i class="icon icon-form-checkbox"></i>
                </div>
                <div class="item-inner">
                  <div class="item-title">
                    Direct Payments <i class="icon-money icon icon-status-label"></i>
                  </div>
                </div>
              </label>
            </li>
          </ul>
        </div>
        <!-- TODO -->
      </div>
      <!-- TODO -->
    </div>
  </div>
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
import datePickerMixin from '@/mixins/datePickerMixin'

export default {
  mixins: [datePickerMixin],
  name: 'MessagesFilter',
  props: {
    received: {
      type: Boolean,
      required: false,
      default: false
    },
    isPayments: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    statusPickerLabel () {
      let that = this
      if (that.filterStatusWaiting && !that.filterStatusNegotiationRequest &&
      !that.filterStatusNegotiationResponse && !that.filterStatusRequestAccepted &&
      !that.filterStatusRequestAborted && !that.filterStatusCreditTransferGenerated &&
      !that.filterStatusBankStatementReceived && !that.filterStatusDirectPayments) {
        return 'Request Waiting'
      } else if (!that.filterStatusWaiting && that.filterStatusNegotiationRequest &&
      !that.filterStatusNegotiationResponse && !that.filterStatusRequestAccepted &&
      !that.filterStatusRequestAborted && !that.filterStatusCreditTransferGenerated &&
      !that.filterStatusBankStatementReceived && !that.filterStatusDirectPayments) {
        return 'Negotiation Request'
      } else if (!that.filterStatusWaiting && !that.filterStatusNegotiationRequest &&
      that.filterStatusNegotiationResponse && !that.filterStatusRequestAccepted &&
      !that.filterStatusRequestAborted && !that.filterStatusCreditTransferGenerated &&
      !that.filterStatusBankStatementReceived && !that.filterStatusDirectPayments) {
        return 'Negotiation Response'
      } else if (!that.filterStatusWaiting && !that.filterStatusNegotiationRequest &&
      !that.filterStatusNegotiationResponse && that.filterStatusRequestAccepted &&
      !that.filterStatusRequestAborted && !that.filterStatusCreditTransferGenerated &&
      !that.filterStatusBankStatementReceived && !that.filterStatusDirectPayments) {
        return 'Request Accepted'
      } else if (!that.filterStatusWaiting && !that.filterStatusNegotiationRequest &&
      !that.filterStatusNegotiationResponse && !that.filterStatusRequestAccepted &&
      that.filterStatusRequestAborted && !that.filterStatusCreditTransferGenerated &&
      !that.filterStatusBankStatementReceived && !that.filterStatusDirectPayments) {
        return 'Request Aborted'
      } else if (!that.filterStatusWaiting && !that.filterStatusNegotiationRequest &&
      !that.filterStatusNegotiationResponse && !that.filterStatusRequestAccepted &&
      !that.filterStatusRequestAborted && that.filterStatusCreditTransferGenerated &&
      !that.filterStatusBankStatementReceived && !that.filterStatusDirectPayments) {
        return 'Credit Transfer Generated'
      } else if (!that.filterStatusWaiting && !that.filterStatusNegotiationRequest &&
      !that.filterStatusNegotiationResponse && !that.filterStatusRequestAccepted &&
      !that.filterStatusRequestAborted && !that.filterStatusCreditTransferGenerated &&
      that.filterStatusBankStatementReceived && !that.filterStatusDirectPayments) {
        return 'Bank Statement Received'
      } else if (!that.filterStatusWaiting && !that.filterStatusNegotiationRequest &&
      !that.filterStatusNegotiationResponse && !that.filterStatusRequestAccepted &&
      !that.filterStatusRequestAborted && !that.filterStatusCreditTransferGenerated &&
      !that.filterStatusBankStatementReceived && that.filterStatusDirectPayments) {
        return 'Direct Payments'
      } else if (!that.filterStatusWaiting && !that.filterStatusNegotiationRequest &&
      !that.filterStatusNegotiationResponse && !that.filterStatusRequestAccepted &&
      !that.filterStatusRequestAborted && !that.filterStatusCreditTransferGenerated &&
      !that.filterStatusBankStatementReceived && !that.filterStatusDirectPayments) {
        return 'Select a status'
      } else {
        return 'Multiple Status Selected'
      }
    },
    statusPickerCloseButton () {
      this.$f7.closeModal('.statusPicker.modal-in')
    }
  },
  data: () => {
    return {
      dir: 0,
      filterDateBegin: '',
      filterDateEnd: '',
      filterReason: '',
      filterName: '',
      calendarDefault: '',
      filterStatusWaiting: false,
      filterStatusNegotiationRequest: false,
      filterStatusNegotiationResponse: false,
      filterStatusRequestAccepted: false,
      filterStatusRequestAborted: false,
      filterStatusCreditTransferGenerated: false,
      filterStatusBankStatementReceived: false,
      filterStatusDirectPayments: false
    }
  },
  mounted () {
    let that = this
    this.dir = this.$settings.msgDirection

    let serviceName = {
      '1': this.$engine.services.payments,
      '2': this.$engine.services.directDebit,
      '6': this.$engine.services.directPayments
    }

    var defaultFilter = serviceName[this.$engine.user.currentService.id].filter.getDefaultFilter()
    this.filterDateBegin = defaultFilter.filterDateBegin
    this.filterDateEnd = defaultFilter.filterDateEnd
    this.filterReason = defaultFilter.filterReason
    this.filterName = defaultFilter.filterName
    if (defaultFilter.filterStatusWaiting === 1) {
      that.filterStatusWaiting = true
      that.Dom7(that.Dom7('.checkboxFilterStatusWaiting')[that.Dom7('.checkboxFilterStatusWaiting').length - 1]).prop('checked', true)
    }
    /* if (defaultFilter.filterStatusNegotiationRequest === 1) {
      that.filterStatusNegotiationRequest = true
      that.Dom7(that.Dom7('.checkboxFilterStatusNegotiationRequest')[that.Dom7('.checkboxFilterStatusNegotiationRequest').length - 1]).prop('checked', true)
    }
    if (defaultFilter.filterStatusNegotiationResponse === 1) {
      that.filterStatusNegotiationResponse = true
      that.Dom7(that.Dom7('.checkboxFilterStatusNegotiationResponse')[that.Dom7('.checkboxFilterStatusNegotiationResponse').length - 1]).prop('checked', true)
    } */
    if (defaultFilter.filterStatusRequestAccepted === 1) {
      that.filterStatusRequestAccepted = true
      that.Dom7(that.Dom7('.checkboxFilterStatusRequestAccepted')[that.Dom7('.checkboxFilterStatusRequestAccepted').length - 1]).prop('checked', true)
    }
    if (defaultFilter.filterStatusRequestAborted === 1) {
      that.filterStatusRequestAborted = true
      that.Dom7(that.Dom7('.checkboxFilterStatusRequestAborted')[that.Dom7('.checkboxFilterStatusRequestAborted').length - 1]).prop('checked', true)
    }
    if (defaultFilter.filterStatusCreditTransferGenerated === 1) {
      that.filterStatusCreditTransferGenerated = true
      that.Dom7(that.Dom7('.checkboxFilterStatusCreditTransferGenerated')[that.Dom7('.checkboxFilterStatusCreditTransferGenerated').length - 1]).prop('checked', true)
    }
    if (defaultFilter.filterStatusBankStatementReceived === 1) {
      that.filterStatusBankStatementReceived = true
      that.Dom7(that.Dom7('.checkboxFilterStatusBankStatementReceived')[that.Dom7('.checkboxFilterStatusBankStatementReceived').length - 1]).prop('checked', true)
    }
    if (defaultFilter.filterStatusDirectPayments === 1) {
      that.filterStatusDirectPayments = true
      that.Dom7(that.Dom7('.checkboxFilterStatusDirectPayments')[that.Dom7('.checkboxFilterStatusDirectPayments').length - 1]).prop('checked', true)
    }

    this.updateChipTags()
  },
  created () {
  },
  methods: {
    getIcon (filterStatusWaiting, filterStatusNegotiationRequest,
    filterStatusNegotiationResponse, filterStatusRequestAccepted,
    filterStatusRequestAborted, filterStatusCreditTransferGenerated,
    filterStatusBankStatementReceived, filterStatusDirectPayments) {
      if (filterStatusWaiting && !filterStatusNegotiationRequest &&
      !filterStatusNegotiationResponse && !filterStatusRequestAccepted &&
      !filterStatusRequestAborted && !filterStatusCreditTransferGenerated &&
      !filterStatusBankStatementReceived && !filterStatusDirectPayments) {
        return 'icon-clock_forward'
      } else if (!filterStatusWaiting && filterStatusNegotiationRequest &&
      !filterStatusNegotiationResponse && !filterStatusRequestAccepted &&
      !filterStatusRequestAborted && !filterStatusCreditTransferGenerated &&
      !filterStatusBankStatementReceived && !filterStatusDirectPayments) {
        return 'icon-message'
      } else if (!filterStatusWaiting && !filterStatusNegotiationRequest &&
      filterStatusNegotiationResponse && !filterStatusRequestAccepted &&
      !filterStatusRequestAborted && !filterStatusCreditTransferGenerated &&
      !filterStatusBankStatementReceived && !filterStatusDirectPayments) {
        return 'icon-messages'
      } else if (!filterStatusWaiting && !filterStatusNegotiationRequest &&
      !filterStatusNegotiationResponse && filterStatusRequestAccepted &&
      !filterStatusRequestAborted && !filterStatusCreditTransferGenerated &&
      !filterStatusBankStatementReceived && !filterStatusDirectPayments) {
        return 'icon-ok'
      } else if (!filterStatusWaiting && !filterStatusNegotiationRequest &&
      !filterStatusNegotiationResponse && !filterStatusRequestAccepted &&
      filterStatusRequestAborted && !filterStatusCreditTransferGenerated &&
      !filterStatusBankStatementReceived && !filterStatusDirectPayments) {
        return 'icon-error'
      } else if (!filterStatusWaiting && !filterStatusNegotiationRequest &&
      !filterStatusNegotiationResponse && !filterStatusRequestAccepted &&
      !filterStatusRequestAborted && filterStatusCreditTransferGenerated &&
      !filterStatusBankStatementReceived && !filterStatusDirectPayments) {
        return 'icon-hand_money'
      } else if (!filterStatusWaiting && !filterStatusNegotiationRequest &&
      !filterStatusNegotiationResponse && !filterStatusRequestAccepted &&
      !filterStatusRequestAborted && !filterStatusCreditTransferGenerated &&
      filterStatusBankStatementReceived && !filterStatusDirectPayments) {
        return 'icon-receipt'
      } else if (!filterStatusWaiting && !filterStatusNegotiationRequest &&
      !filterStatusNegotiationResponse && !filterStatusRequestAccepted &&
      !filterStatusRequestAborted && !filterStatusCreditTransferGenerated &&
      !filterStatusBankStatementReceived && filterStatusDirectPayments) {
        return 'icon-money'
      } else if (!filterStatusWaiting && !filterStatusNegotiationRequest &&
      !filterStatusNegotiationResponse && !filterStatusRequestAccepted &&
      !filterStatusRequestAborted && !filterStatusCreditTransferGenerated &&
      !filterStatusBankStatementReceived && !filterStatusDirectPayments) {
        return ''
      } else {
        return ''
      }
    },
    cleanFilter () {
      let that = this
      this.$f7.showPreloader('Loading page')
      let serviceName = {
        '1': this.$engine.services.payments,
        '2': this.$engine.services.directDebit,
        '6': this.$engine.services.directPayments
      }
      let actualService = serviceName[this.$engine.user.currentService.id]

      actualService.filter.cleanFilterCondition()

      this.cleanMultipleStatusPicker()

      this.filterDateBegin = ''
      this.filterDateEnd = ''
      this.filterReason = ''
      this.filterName = ''
      /* this.$engine.services.payments.update(this.dir, 15, 1, that.$engine.services.payments.filter.getConditionObject())
      .then(resp => {
        let payments = resp.data.payments
        if (that.dir === 0) {
          that.$bus.$emit('inbox-filtered', payments)
        } else {
          that.$bus.$emit('sendbox-filtered', payments)
        }
        that.$f7.hidePreloader()
      })
      .catch(error => {
        that.$f7.hidePreloader()
        errorMessageAlert(error, that)
      }) */
      that.Dom7(that.Dom7('.statusChip')[that.Dom7('.statusChip').length - 1]).addClass('hiddenElement')
      that.Dom7(that.Dom7('.dateBeginChip')[that.Dom7('.dateBeginChip').length - 1]).addClass('hiddenElement')
      that.Dom7(that.Dom7('.dateEndChip')[that.Dom7('.dateEndChip').length - 1]).addClass('hiddenElement')
      that.Dom7(that.Dom7('.reasonChip')[that.Dom7('.reasonChip').length - 1]).addClass('hiddenElement')
      that.Dom7(that.Dom7('.creditorNameChip')[that.Dom7('.creditorNameChip').length - 1]).addClass('hiddenElement')
      that.Dom7(that.Dom7('.filterChipBlock')[that.Dom7('.filterChipBlock').length - 1]).addClass('hiddenElement')
      // this.$f7.accordionClose('.accordion-item', true)
      /* let defaultFilter = {
        filterDateBegin: this.filterDateBegin,
        filterDateEnd: this.filterDateEnd,
        filterReason: this.filterReason,
        filterName: this.filterName,
        filterStatusWaiting: that.filterStatusWaiting === true ? 1 : 0,
        filterStatusNegotiationRequest: that.filterStatusNegotiationRequest === true ? 1 : 0,
        filterStatusNegotiationResponse: that.filterStatusNegotiationResponse === true ? 1 : 0,
        filterStatusRequestAccepted: that.filterStatusRequestAccepted === true ? 1 : 0,
        filterStatusRequestAborted: that.filterStatusRequestAborted === true ? 1 : 0,
        filterStatusBankStatementReceived: that.filterStatusBankStatementReceived === true ? 1 : 0,
        filterStatusCreditTransferGenerated: that.filterStatusCreditTransferGenerated === true ? 1 : 0,
        filterStatusDirectPayments: that.filterStatusDirectPayments === true ? 1 : 0
      }

      that.$engine.services.directPayments.filter.saveDefaultFilter(defaultFilter) */
      that.$f7.hidePreloader()
    },
    updatePaymentsList () {
      let that = this

      let serviceName = {
        '1': this.$engine.services.payments,
        '2': this.$engine.services.directDebit,
        '6': this.$engine.services.directPayments
      }
      let actualService = serviceName[this.$engine.user.currentService.id]

      if (this.$engine.user.currentService.id === '1') {
        this.$f7.showPreloader('Loading page')
      }

      actualService.filter.cleanFilterCondition()

      actualService.filter.dateBegin = this.filterDateBegin
      actualService.filter.dateEnd = this.filterDateEnd
      actualService.filter.creditorOrDebtorName = this.filterName
      actualService.filter.reason = this.filterReason

      if (that.filterStatusWaiting) {
        actualService.filter.statusWaiting = 1
      }
      if (that.filterStatusNegotiationRequest) {
        actualService.filter.statusNegotiationRequest = 1
      }
      if (that.filterStatusNegotiationResponse) {
        actualService.filter.statusNegotiationResponse = 1
      }
      if (that.filterStatusRequestAccepted) {
        actualService.filter.statusRequestAccepted = 1
      }
      if (that.filterStatusRequestAborted) {
        actualService.filter.statusRequestAborted = 1
      }
      if (that.filterStatusCreditTransferGenerated) {
        actualService.filter.statusCreditTransferGenerated = 1
      }
      if (that.filterStatusBankStatementReceived) {
        actualService.filter.statusBankStatementReceived = 1
      }
      if (that.filterStatusDirectPayments) {
        actualService.filter.statusDirectPayments = 1
      }

      this.updateChipTags()
      if (this.$engine.user.currentService.id === '1') {
        this.$engine.services.payments.update(this.dir, 15, 1, actualService.filter.getConditionObject())
        .then(resp => {
          let payments = resp.data.payments
          if (that.dir === 0) {
            that.$bus.$emit('inbox-filtered', payments)
            that.$f7.hidePreloader()
          } else {
            that.$bus.$emit('sendbox-filtered', payments)
            that.$f7.hidePreloader()
          }
          that.$f7.hidePreloader()
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
        })
      } else {
        if (that.dir === 0) {
          that.$bus.$emit('direct-inbox-filtered', 1)
        } else {
          that.$bus.$emit('direct-sendbox-filtered', 1)
        }
      }
    },
    onFilterChipDelete (chipName) {
      let that = this
      this.$f7.showPreloader('Loading page')

      let serviceName = {
        '1': this.$engine.services.payments,
        '2': this.$engine.services.directDebit,
        '6': this.$engine.services.directPayments
      }
      let actualService = serviceName[this.$engine.user.currentService.id]

      switch (chipName) {
        case 'statusChip':
          that.Dom7(that.Dom7('.statusChip')[that.Dom7('.statusChip').length - 1]).addClass('hiddenElement')
          actualService.filter.cleanFilterStatusCondition()
          this.cleanMultipleStatusPicker()
          break
        case 'dateBeginChip':
          that.Dom7(that.Dom7('.dateBeginChip')[that.Dom7('.dateBeginChip').length - 1]).addClass('hiddenElement')
          actualService.filter.dateBegin = ''
          this.filterDateBegin = ''
          break
        case 'dateEndChip':
          that.Dom7(that.Dom7('.dateEndChip')[that.Dom7('.dateEndChip').length - 1]).addClass('hiddenElement')
          actualService.filter.dateEnd = ''
          this.filterDateEnd = ''
          break
        case 'reasonChip':
          that.Dom7(that.Dom7('.reasonChip')[that.Dom7('.reasonChip').length - 1]).addClass('hiddenElement')
          actualService.filter.reason = ''
          this.filterReason = ''
          break
        case 'creditorNameChip':
          that.Dom7(that.Dom7('.creditorNameChip')[that.Dom7('.creditorNameChip').length - 1]).addClass('hiddenElement')
          actualService.filter.creditorOrDebtorName = ''
          this.filterName = ''
      }
      if (actualService.filter.ifHaveConditions()) {
        that.Dom7(that.Dom7('.filterChipBlock')[that.Dom7('.filterChipBlock').length - 1]).removeClass('hiddenElement')
      } else {
        that.Dom7(that.Dom7('.filterChipBlock')[that.Dom7('.filterChipBlock').length - 1]).addClass('hiddenElement')
      }
      actualService.update(this.dir, 15, 1, actualService.filter.getConditionObject())
      .then(resp => {
        let payments = resp.data.payments
        if (that.dir === 0) {
          that.$bus.$emit('inbox-filtered', payments)
        } else {
          that.$bus.$emit('sendbox-filtered', payments)
        }
        that.$f7.hidePreloader()
      })
      .catch(error => {
        that.$f7.hidePreloader()
        errorMessageAlert(error, that)
      })
    },
    updateChipTags () {
      let that = this
      let serviceName = {
        '1': this.$engine.services.payments,
        '2': this.$engine.services.directDebit,
        '6': this.$engine.services.directPayments
      }
      let actualService = serviceName[this.$engine.user.currentService.id]

      if (actualService.filter.ifHaveConditions()) {
        that.Dom7(that.Dom7('.filterChipBlock')[that.Dom7('.filterChipBlock').length - 1]).removeClass('hiddenElement')
      } else {
        that.Dom7(that.Dom7('.filterChipBlock')[that.Dom7('.filterChipBlock').length - 1]).addClass('hiddenElement')
      }

      if (actualService.filter.ifHaveStatusConditions()) {
        that.Dom7(that.Dom7('.statusChip')[that.Dom7('.statusChip').length - 1]).removeClass('hiddenElement')
      } else {
        that.Dom7(that.Dom7('.statusChip')[that.Dom7('.statusChip').length - 1]).addClass('hiddenElement')
      }
      if (actualService.filter.dateBegin !== '' && actualService.filter.dateBegin !== undefined) {
        that.Dom7(that.Dom7('.dateBeginChip')[that.Dom7('.dateBeginChip').length - 1]).removeClass('hiddenElement')
      } else {
        that.Dom7(that.Dom7('.dateBeginChip')[that.Dom7('.dateBeginChip').length - 1]).addClass('hiddenElement')
      }
      if (actualService.filter.dateEnd !== '' && actualService.filter.dateEnd !== undefined) {
        that.Dom7(that.Dom7('.dateEndChip')[that.Dom7('.dateEndChip').length - 1]).removeClass('hiddenElement')
      } else {
        that.Dom7(that.Dom7('.dateEndChip')[that.Dom7('.dateEndChip').length - 1]).addClass('hiddenElement')
      }
      if (actualService.filter.creditorOrDebtorName !== '' && actualService.filter.creditorOrDebtorName !== undefined) {
        that.Dom7(that.Dom7('.creditorNameChip')[that.Dom7('.creditorNameChip').length - 1]).removeClass('hiddenElement')
      } else {
        that.Dom7(that.Dom7('.creditorNameChip')[that.Dom7('.creditorNameChip').length - 1]).addClass('hiddenElement')
      }
      if (actualService.filter.reason !== '' && actualService.filter.reason !== undefined) {
        that.Dom7(that.Dom7('.reasonChip')[that.Dom7('.reasonChip').length - 1]).removeClass('hiddenElement')
      } else {
        that.Dom7(that.Dom7('.reasonChip')[that.Dom7('.reasonChip').length - 1]).addClass('hiddenElement')
      }
    },
    calendarDateBegin ($event) {
      /* eslint-disable no-undef */
      let that = this

      if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
        var options = {
          date: new Date(),
          mode: 'date'
        }
        datePicker.show(options, function (date) {
          let year = date.getFullYear().toString()
          let month = (date.getMonth() + 1).toString().length > 1 ? (date.getMonth() + 1).toString() : '0' + (date.getMonth() + 1).toString()
          let day = date.getDate().toString().length > 1 ? date.getDate().toString() : '0' + date.getDate().toString()
          let dateResult = year + '-' + month + '-' + day
          that.filterDateBegin = dateResult
          // that.Dom7($event.target).text(dateResult)
        })
      } else {
      }
      /* eslint-enable no-undef */
    },
    paymentsDateBegin (index) {
      if (this.filterDateBegin !== undefined) {
        if (this.filterDateBegin.length > 0) {
          return this.filterDateBegin
        } else {
          return 'Select a date'
        }
      } else {
        return 'Select a date'
      }
    },
    calendarDateEnd ($event) {
      /* eslint-disable no-undef */
      let that = this

      if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
        var options = {
          date: new Date(),
          mode: 'date'
        }
        datePicker.show(options, function (date) {
          let year = date.getFullYear().toString()
          let month = (date.getMonth() + 1).toString().length > 1 ? (date.getMonth() + 1).toString() : '0' + (date.getMonth() + 1).toString()
          let day = date.getDate().toString().length > 1 ? date.getDate().toString() : '0' + date.getDate().toString()
          let dateResult = year + '-' + month + '-' + day
          that.filterDateEnd = dateResult
        })
      } else {
      }
      /* eslint-enable no-undef */
    },
    paymentsDateEnd (index) {
      if (this.filterDateEnd !== undefined) {
        if (this.filterDateEnd.length > 0) {
          return this.filterDateEnd
        } else {
          return 'Select a date'
        }
      } else {
        return 'Select a date'
      }
    },
    saveDefaultFilter () {
      let that = this
      let serviceName = {
        '1': this.$engine.services.payments,
        '2': this.$engine.services.directDebit,
        '6': this.$engine.services.directPayments
      }

      let actualService = serviceName[this.$engine.user.currentService.id]

      let defaultFilter = {
        filterDateBegin: this.filterDateBegin,
        filterDateEnd: this.filterDateEnd,
        filterReason: this.filterReason,
        filterName: this.filterName,
        filterStatusWaiting: that.filterStatusWaiting === true ? 1 : 0,
        filterStatusNegotiationRequest: that.filterStatusNegotiationRequest === true ? 1 : 0,
        filterStatusNegotiationResponse: that.filterStatusNegotiationResponse === true ? 1 : 0,
        filterStatusRequestAccepted: that.filterStatusRequestAccepted === true ? 1 : 0,
        filterStatusRequestAborted: that.filterStatusRequestAborted === true ? 1 : 0,
        filterStatusBankStatementReceived: that.filterStatusBankStatementReceived === true ? 1 : 0,
        filterStatusCreditTransferGenerated: that.filterStatusCreditTransferGenerated === true ? 1 : 0,
        filterStatusDirectPayments: that.filterStatusDirectPayments === true ? 1 : 0
      }

      actualService.filter.saveDefaultFilter(defaultFilter)
      that.$f7.modal({
        title: 'Default filter saved',
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    cleanMultipleStatusPicker () {
      let that = this
      that.filterStatusWaiting = false
      that.filterStatusNegotiationRequest = false
      that.filterStatusNegotiationResponse = false
      that.filterStatusRequestAccepted = false
      that.filterStatusRequestAborted = false
      that.filterStatusCreditTransferGenerated = false
      that.filterStatusBankStatementReceived = false
      that.filterStatusDirectPayments = false
      that.Dom7(that.Dom7('.checkboxFilterStatusWaiting')[that.Dom7('.checkboxFilterStatusWaiting').length - 1]).prop('checked', false)
      that.Dom7(that.Dom7('.checkboxFilterStatusNegotiationRequest')[that.Dom7('.checkboxFilterStatusNegotiationRequest').length - 1]).prop('checked', false)
      that.Dom7(that.Dom7('.checkboxFilterStatusNegotiationResponse')[that.Dom7('.checkboxFilterStatusNegotiationResponse').length - 1]).prop('checked', false)
      that.Dom7(that.Dom7('.checkboxFilterStatusRequestAccepted')[that.Dom7('.checkboxFilterStatusRequestAccepted').length - 1]).prop('checked', false)
      that.Dom7(that.Dom7('.checkboxFilterStatusRequestAborted')[that.Dom7('.checkboxFilterStatusRequestAborted').length - 1]).prop('checked', false)
      that.Dom7(that.Dom7('.checkboxFilterStatusCreditTransferGenerated')[that.Dom7('.checkboxFilterStatusCreditTransferGenerated').length - 1]).prop('checked', false)
      that.Dom7(that.Dom7('.checkboxFilterStatusBankStatementReceived')[that.Dom7('.checkboxFilterStatusBankStatementReceived').length - 1]).prop('checked', false)
      that.Dom7(that.Dom7('.checkboxFilterStatusDirectPayments')[that.Dom7('.checkboxFilterStatusDirectPayments').length - 1]).prop('checked', false)
    },
    changeFilterStatusWaiting (obj) {
      this.filterStatusWaiting = obj.target.checked
    },
    changeFilterStatusNegotiationRequest (obj) {
      this.filterStatusNegotiationRequest = obj.target.checked
    },
    changeFilterStatusNegotiationResponse (obj) {
      this.filterStatusNegotiationResponse = obj.target.checked
    },
    changeFilterStatusRequestAccepted (obj) {
      this.filterStatusRequestAccepted = obj.target.checked
    },
    changeFilterStatusRequestAborted (obj) {
      this.filterStatusRequestAborted = obj.target.checked
    },
    changeFilterStatusCreditTransferGenerated (obj) {
      this.filterStatusCreditTransferGenerated = obj.target.checked
    },
    changeFilterStatusBankStatementReceived (obj) {
      this.filterStatusBankStatementReceived = obj.target.checked
    },
    changeFilterStatusDirectPayments (obj) {
      this.filterStatusDirectPayments = obj.target.checked
    }
  }
}
</script>

<style scoped>
.filterType .label {
  width: 40%;
}
.filterChipBlockTitle {
  margin-bottom: 0px;
  padding-top: 20px;
  background-color: #EEEEEE;
  color: #000000;
  font-size: 15px;
}
.filterChipBlock {
  padding-bottom: 5px;
  padding-top: 5px;
  margin-bottom: 0px;
  background-color: #EEEEEE;
}
.icon-status-label {
  width: 22px;
  height: 22px;
  background-size: contain;
  margin-top: -4px;
  /* vertical-align: baseline !important; */
}
.filterFontSize {
  font-size: 14px !important;
}

.filterLabelWidth {
  width:35% !important;
}

.form-control {
  width: calc(100% - 190px);
  margin-left: 90px;
  height: auto;
  padding: 0;
  padding-left: 5%;
}
.list-block .item-title.label {
  width: auto;
}

::-webkit-input-placeholder {
  color: #A7A7A7;
}

label {
  margin-bottom: 0%;
}
</style>



// WEBPACK FOOTER //
// Filter.vue?565b0b1f